"use strict";
/*
 * Created on 10 15 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * UserProductCategory encapsulates binding between {@link User user} and {@link ProductCategory product category}.
 * Information from this class should be readonly, you should never reference the concrete binding.
 *
 * @author JMe
 */


var UserProductCategory =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(UserProductCategory, _DomainObject_1$Domai);

  /**
   * @param id the internal id
   * @param userId the external id of user (fixme or do we have users in separate collection?)
   * @param categoryId the internal id of category
   * @param processed defines whether an instance was processed, eg. within data import
   */
  function UserProductCategory(id, userId, categoryId, processed) {
    var _this;

    _classCallCheck(this, UserProductCategory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserProductCategory).call(this));
    _this.id = id;
    _this.userId = userId;
    _this.categoryId = categoryId;
    _this.processed = processed;
    return _this;
  }

  return UserProductCategory;
}(DomainObject_1.DomainObject);

exports.UserProductCategory = UserProductCategory; // tslint:disable-next-line:member-ordering

UserProductCategory.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(UserProductCategory.name);
  return {
    id: builder.id('id'),
    userId: builder.id('userId'),
    categoryId: builder.id('categoryId'),
    processed: builder.bool('processed')
  };
}();